function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebhooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M44.36 23.95c0 3.18-.06 6.37.02 9.55.04 1.7-.66 2.75-2.11 3.54-2.55 1.39-5.03 2.9-7.55 4.35-2.46 1.42-4.92 2.83-7.37 4.25-.8.46-1.58.95-2.4 1.39-.82.44-1.64.36-2.44-.11-2.42-1.41-4.85-2.82-7.27-4.23-2.36-1.38-4.72-2.76-7.09-4.14-1.16-.68-2.33-1.33-3.49-2.01-.81-.48-1.25-1.17-1.25-2.15.01-6.96.01-13.91 0-20.87 0-1.05.49-1.75 1.38-2.26 2.14-1.23 4.26-2.48 6.4-3.72 2.22-1.29 4.45-2.57 6.67-3.85 1.51-.87 3.04-1.72 4.52-2.64.99-.61 1.92-.59 2.89-.03 3.59 2.08 7.17 4.16 10.76 6.24 2.35 1.37 4.69 2.75 7.04 4.12.92.53 1.26 1.37 1.26 2.36.05 3.4.03 6.81.03 10.21zm-22.69 1.5c-.11.27-.19.49-.28.7-1.05 2.44-2.1 4.87-3.14 7.31-.33.77-.16 1.5.41 1.9.67.48 1.35.42 2.01-.17.42-.37.84-.72 1.26-1.09l10.25-8.96c.67-.59.77-1.43.24-2.12-.34-.43-.81-.57-1.34-.57h-4.8c.11-.27.19-.48.28-.7 1.03-2.43 2.06-4.85 3.09-7.28.33-.78.17-1.5-.4-1.91-.63-.46-1.34-.43-1.98.13-1.97 1.7-3.92 3.42-5.88 5.13-1.9 1.66-3.8 3.3-5.67 4.99-.26.24-.48.63-.53.98-.13.94.56 1.65 1.51 1.66h4.97z",
    style: {
      fill: "#def0ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.67 25.45h-4.98c-.96 0-1.65-.72-1.51-1.66.05-.35.26-.75.53-.98 1.87-1.68 3.78-3.33 5.67-4.99l5.88-5.13c.64-.56 1.35-.59 1.98-.13.57.41.73 1.13.4 1.91-1.03 2.43-2.06 4.86-3.09 7.28-.09.21-.17.43-.28.7h4.8c.53 0 1 .14 1.34.57.53.68.43 1.53-.24 2.12-3.41 2.99-6.83 5.97-10.25 8.96-.42.36-.84.72-1.26 1.09-.66.59-1.34.65-2.01.17-.57-.41-.74-1.14-.41-1.9 1.04-2.44 2.1-4.87 3.14-7.31.1-.21.18-.43.29-.7z",
    style: {
      fill: "#4bba78"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebhooks);
export default __webpack_public_path__ + "static/media/webhooks.b6d193ebab486c5a44bef37c8027a508.svg";
export { ForwardRef as ReactComponent };